import createIcon from '../../createIcon';

/**
 * @component @name Filter8
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA1SDFWMjFDMSAyMi4xIDEuOSAyMyAzIDIzSDE5VjIxSDNWNVpNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0yMSAxN0g3VjNIMjFWMTdaTTEzIDE1SDE1QzE2LjEgMTUgMTcgMTQuMTEgMTcgMTNWMTEuNUMxNyAxMC42NyAxNi4zMyAxMCAxNS41IDEwQzE2LjMzIDEwIDE3IDkuMzMgMTcgOC41VjdDMTcgNS44OSAxNi4xIDUgMTUgNUgxM0MxMS45IDUgMTEgNS44OSAxMSA3VjguNUMxMSA5LjMzIDExLjY3IDEwIDEyLjUgMTBDMTEuNjcgMTAgMTEgMTAuNjcgMTEgMTEuNVYxM0MxMSAxNC4xMSAxMS45IDE1IDEzIDE1Wk0xMyA3SDE1VjlIMTNWN1pNMTMgMTFIMTVWMTNIMTNWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter8 = createIcon('Filter8', [
  [
    'path',
    {
      d: 'M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15H15C16.1 15 17 14.11 17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H13C11.9 5 11 5.89 11 7V8.5C11 9.33 11.67 10 12.5 10C11.67 10 11 10.67 11 11.5V13C11 14.11 11.9 15 13 15ZM13 7H15V9H13V7ZM13 11H15V13H13V11Z',
      key: 'vmbe5n',
    },
  ],
]);

export default Filter8;
